import { useCallback } from 'react'
import useTranslation from 'next-translate/useTranslation'

import useGoogleMapsScript, {
  GoogleMapsLibrary,
} from '../../app/hooks/useGoogleMapsScript'
import getLanguageCode from '../../app/utils/getLanguageCode'

export default function usePlacesAutoComplete() {
  const { lang } = useTranslation()

  const scriptStatus = useGoogleMapsScript([GoogleMapsLibrary.Places])

  const fetchPredictions = useCallback(
    async (query: string) => {
      if (window.google && window.google.maps?.places?.AutocompleteSuggestion) {
        const results =
          await window.google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
            {
              input: query,
              includedRegionCodes: ['se', 'no'],
              language: getLanguageCode(lang),
            },
          )

        return results.suggestions
      }

      return []
    },
    [lang],
  )

  return {
    scriptStatus,
    fetchPredictions,
  }
}
